import {data} from './data';

export const references = {
	title: 'References',

	showMore: 'Show more',
	showLess: 'Show less',

	country: 'Country',
	location: 'Location',
	completion: 'Completion',
	investor: 'Investor',
	architect: 'General Designer',
	author: 'Proposal Author',

	data,
};
